<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ nome }}</h2>
        <span class="modal-subtitle">Hierarquia</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    @if (isLoading) {
    <div class="hierarquia-loading">Carregando...</div>
    } @else {

    <div class="hierarquia-secao">
        @if (ancestrais.length === 0) {
        <div class="hierarquia-nota">Sem vendedor responsável — este cadastro é raiz da hierarquia.</div>
        } @else {
        <div class="hierarquia-breadcrumb">
            @for (ancestral of ancestrais; track ancestral.idVendedor; let last = $last) {
            <button type="button" class="hierarquia-breadcrumb-item" (click)="carregar(ancestral.idVendedor)">
                {{ ancestral.nome }}
            </button>
            @if (!last) {
            <mat-icon class="hierarquia-breadcrumb-seta">chevron_right</mat-icon>
            }
            }
            <mat-icon class="hierarquia-breadcrumb-seta">chevron_right</mat-icon>
            <span class="hierarquia-breadcrumb-atual">{{ nome }}</span>
        </div>
        }
    </div>

    <div class="hierarquia-secao">
        @if (subordinados.length === 0) {
        <div class="hierarquia-nota">Nenhum vendedor responde a este cadastro.</div>
        } @else {
        <div class="hierarquia-total">{{ totalNaCadeia }} na cadeia</div>

        <ng-container *ngTemplateOutlet="nivelTpl; context: { nos: subordinados }"></ng-container>

        <ng-template #nivelTpl let-nos="nos">
            <ul class="hierarquia-arvore">
                @for (no of nos; track no.idVendedor) {
                <li>
                    <div class="hierarquia-no">
                        @if (no.subordinados.length > 0) {
                        <button type="button" class="hierarquia-no-toggle" (click)="toggleExpandido(no.idVendedor)">
                            <mat-icon>{{ expandido.has(no.idVendedor) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                        </button>
                        } @else {
                        <span class="hierarquia-no-folha">—</span>
                        }
                        <span class="hierarquia-no-nome">{{ no.nome }}</span>
                        @if (no.qtdSubordinadosDiretos > 0) {
                        <span class="hierarquia-no-contador">{{ no.qtdSubordinadosDiretos }}</span>
                        }
                    </div>
                    @if (no.subordinados.length > 0 && expandido.has(no.idVendedor)) {
                    <ng-container *ngTemplateOutlet="nivelTpl; context: { nos: no.subordinados }"></ng-container>
                    }
                </li>
                }
            </ul>
        </ng-template>
        }
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Fechar</button>
    <button mat-flat-button class="btn-primary" (click)="editarCadastro()">Editar cadastro</button>
</mat-dialog-actions>
